<template>
  <div class="homePage">
    <home-banner ref="homeBanner" :height="535"></home-banner>
    <!-- hot -->
    <div class="TTouTiao">
      <div class="Tl"></div>
      <div class="Tr"> 
        <el-carousel  direction="vertical" :interval="3000" indicator-position="none">
        <el-carousel-item v-for="(item, index) in newsTextList" :key="index">
          <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }} </a>
          <router-link
            v-else
            target="_blank"
            :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
            > {{ item.title }}
          </router-link>     
        </el-carousel-item>
      </el-carousel>
           
      </div>
    </div>
    <!-- 新闻动态第一部分 -->
    <div class="Tpage Part1" id="part1">
      <!-- 新闻列表图片轮播图 -->
      <div class="NewsL">
        <div id="newsFlashItem" style="width:100%; overflow:hidden;">
          <div class="flashImg" style="display: block;">
            <div class="flashImg-container swiper-container" id="newsFlash">
              <div class="flashImg-wrapper swiper-wrapper"  >
                <div class="flashImg-slide swiper-slide"  v-for="(item,index) in flashImgList11" :key="index" >
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;"
                  >
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>              
          </div>
        </div>  
                          
      </div>
      <!-- 新闻内容列表第一部分 -->      
      <div class="NewsR">
        <div class="Tit" id="NewsT" >
          <div 
            class="NewsRInner"
            :class="{ active: activeNewsJt == index }"
            v-for="(item,index) in catalogList" 
            :key="index"
            @mouseenter="mouseenterNewsJt(index)"
          >
          <!-- mouseenter 鼠标进入事件，当鼠标进入时获取 catalogList 目录的index ， 将目录的index 的值赋给activeNewsJt -->
          <!-- v-if 进行判断，当index等于确定值时，显示新闻列表ul -->
            <a :href="item.url">{{item.title}}
              <img v-if="activeNewsJt == index" src="../assets/img/com_tit_b.png">
            </a>
          </div>
        </div>
        <div class="ItemList" >
          <div class="NewsItem" >
            <ul class="comUl" v-if="activeNewsJt == 0">
              <li v-for="(item,index) in newCatalogList01" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 1">
              <li v-for="(item,index) in newCatalogList02" :key="index">
                <div>
                  <img src="../assets/img/li.png"/>
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/yiji00020002/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 2">
              <li v-for="(item,index) in newCatalogList03" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 3">
              <li v-for="(item,index) in newCatalogList04" :key="index">
                <div>
                  <img src="../assets/img/li.png"/>
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <!-- 党建轮播图 -->
    <div class="Part2" >
      <div class="swiper-container" id="party">
        <div class="swiper-wrapper" >
          <div class="swiper-slide"  v-for="(item,index) in partyimgList" :key="index" >
            <!-- <div v-if="item.urlType == 1">
              <a v-if="!item.url && item.url ==''" >
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
              <a v-else :href="item.url" target="_blank" > 
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
            </div>
            <div v-if="item.urlType != 1 " >
              <a v-if="!item.url && item.url ==''" >
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
              <a v-else :href="item.url" target="_blank" > 
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
            </div> -->
            <a v-if="!item.url && item.url ==''" >
              <img class="swiper_img" :src="item.fileName" style="width: 100%;">
            </a>
            <a v-else :href="item.url" target="_blank" > 
              <img class="swiper_img" :src="item.fileName" style="width: 100%;">
            </a>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-party"></div>
      </div>
    </div>
    <!-- 新闻动态第二部分 -->
    <div class="Tpage Part3" id="part3">      
      <!-- 新闻内容列表 -->      
      <div class="NewsR">
        <div class="Tit" id="NewsT" >
          <div 
            class="NewsRInner"
            :class="{ active: activeNewBasic == index }"
            v-for="(item,index) in catalogList2" 
            :key="index"
            @mouseenter="mouseenterB2(index)"
          >
            <a :href="item.url">{{item.title}}
              <img v-if="activeNewBasic == index" src="../assets/img/com_tit_b.png">
            </a>
          </div>
        </div>

        <div class="ItemList" >
          <div class="NewsItem" >
            <ul class="comUl" v-if="activeNewBasic == 0">
              <li v-for="(item,index) in activeNewBasic1" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewBasic == 1">
              <li v-for="(item,index) in activeNewBasic2" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewBasic == 2">
              <li v-for="(item,index) in activeNewBasic3" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
          </div>
        </div>
      </div>

      <!-- 新闻列表图片轮播图 -->
      <div class="NewsL">
        <div id="newsFlashItem" style="width:100%; overflow:hidden;">
          <div class="flashImg" style="display: block;">
            <div class="flashImg-container swiper-container" id="newsFlash22">
              <div class="flashImg-wrapper swiper-wrapper"  >
                <div class="flashImg-slide swiper-slide"  v-for="(item,index) in flashImgList22" :key="index" >
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank"
                  >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>              
          </div>
        </div>                  
      </div>
    </div>
    <div class="clear"></div>
    <div class="Part4">
      <div class="Tpage">
        <a href=""><img src="../assets/img/p31.png"> </a>
        <a href="" class="tpageImg"><img src="../assets/img/p32.png"> </a>
        <a href="/report" class="tpageImg" target="_blank"><img src="../assets/img/jb11.png"> </a>
      </div>
    </div>
    <div class="clear"></div>
     <!-- 新闻动态第三部分 -->
    <div class="Tpage Part5" id="part5">
      <!-- 视频 -->
      <div class="NewsL">
        <video class="groupVideo" controls="" preload="none"  src="../assets/img/yjnewvideo231024.mp4"   muted="" poster="../assets/img/video.jpg" style="width: 100%; height: 100%;">
          <source src="../assets/img/yjnewvideo231024.mp4" type="video/mp4">
        </video>                   
      </div>
      
      <!-- 新闻内容列表第三部分 -->      
      <div class="NewsR">
        <div class="Tit" id="NewsT" >
          <div 
            class="NewsRInner"
            :class="{ active: activeNewStudy == index }"
            v-for="(item,index) in catalogList3" 
            :key="index"
            @mouseenter="mouseenterStudy(index)"
          >
            <a :href="item.url">{{item.title}}
              <img v-if="activeNewStudy == index" src="../assets/img/com_tit_b.png">
            </a>
          </div>
        </div>
        <div class="ItemList" >
          <div class="NewsItem" >
            <ul class="comUl" v-if="activeNewStudy == 0">
              <li v-for="(item,index) in activeNenStu01" :key="index">
                <div>
                  <img   src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewStudy == 1">
              <li v-for="(item,index) in activeNenStu02" :key="index">
                <div>
                  <img   src="../assets/img/li.png" />
                  <span> 
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                    <router-link
                      v-else
                      target="_blank"
                      :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
            <ul class="comUl" v-if="activeNewStudy == 2">
              <li v-for="(item,index) in activeNenStu03" :key="index">
                <div>
                  <img   src="../assets/img/li.png" />
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                  <router-link
                    v-else
                    target="_blank"
                    :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    >{{ item.title }}
                  </router-link>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>                     
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <!-- 精品项目轮播图 -->
    <div class="Tpage Part6">
      <div class="tit">
        <div class="b">
          精品展示
        </div>
      </div>
      <div class="main_panel" id="Jpgc">     
        <div class="JpgcSwiper-container swiper-container" id="jpgcPhoto">
          <div class="JpgcSwiper-wrapper swiper-wrapper" >
            <div class="JpgcSwiper-slide swiper-slide"  v-for="(item,index) in JpgcPlayList" :key="index" >
              <a :href="item.url" v-if="item.url && item.url !== ''" class="JpItem" target="_blank" >
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; ">
                </div>
                <div class="Tit" >{{item.title }} </div>
                <div class="btn">查看详情</div>
              </a>
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; ">
                </div>
                <div class="Tit" >{{item.title }} </div>
                <div class="btn">查看详情</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <a href="/listPic/yiji0007" target="_blank" class="jpmore">查看更多</a>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"
import homeBanner from "@/components/swiper.vue"
import { articles, getTopArtList,picArticles,getAdvert, getAllArtListByParentUuid} from '@/api/common'
  export default {
    components: {
      homeBanner
    },
    data(){
      return {
        activeNewsJt: 0,
        activeNewBasic : 0,
        activeNewStudy: 0,
        active: 0,
        ismouseover: true,
        //第一个新闻列表
        newCatalogList01: [],
        newCatalogList02: [],
        newCatalogList03: [],
        newCatalogList04: [], 
        // 第二个新闻列表
        activeNewBasic2: [],
        activeNewBasic1: [],
        activeNewBasic3: [],
        // 第三个新闻列表
        activeNenStu01: [],
        activeNenStu02: [],
        activeNenStu03: [],

        newsFlashList01: [],  
        JpgcPlayList: [], 
        //新闻列表轮播图
        flashImgList:[],
        //两个新闻图片的轮播
        flashImgList11: [],
        flashImgList22: [],
        //新闻目录一
        catalogList:[
          {
            id: 1,
            url: '/list/yiji00020001',
            title: '公司要闻',
          },
          {
            id: 2,
            url: '/list/yiji00020002',
            title: '建投要闻',
          },
          {
            id: 3,
            url: '/list/yij3',
            title: '党群工作',
          },
          {
            id: 4,
            url: '/list/yiji00020005',
            title: '媒体聚焦',
          },

        ],
        //党建轮播图
        partyimgList:[],
        //新闻目录二
        catalogList2:[
          {
            id: 1,
            url: '/list/yiji00020003',
            title: '基层动态',
          },
          {
            id: 2,
            url: '/list/yiji000600020001',
            title: '招标公告',
          },
          {
            id: 3,
            url: '/list/yiji00020004',
            title: '行业动态',
          },

        ],
        //新闻目录三
        catalogList3:[
          {
            id: 1,
            url: '/list/yij5',
            title: '学习园地',
          },
          {
            id: 2,
            url: '/list/yiji00040003',
            title: '职工文苑',
          },
          {
            id: 3,
            url: '/list/yiji00040001',
            title: '一建之声',
          },

        ],
        newsTextList: [],
      }
    },
    mounted() {
      this.bannerJpgc()
      this.getTopArtList()
      this.newsCatalog()
      this.picArticles()
      this.bannerImg()
    },
    methods: {
      mouseenterNewsJt(val) {
        this.activeNewsJt = val
      },
      mouseenterB2(val){
        this.activeNewBasic = val
      },
      mouseenterStudy(val){
        this.activeNewStudy = val
      },
      // 党建轮播
      bannerImg() {
        var _this = this
        let data = {
          applicationUuid: _this.webId,
          advertType: 3,
        }
        getAdvert(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.partyimgList = data
            this.$nextTick(() => {
              new Swiper('#party', {
                effect : 'fade',
                loop: true,
                speed: 300,
                autoplay: 3000,
                updateOnImagesReady: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                autoplayDisableOnInteraction: false,
                pagination : '.swiper-pagination-party',
                paginationClickable :true,
              })
            })
          }
        })
      },
      //精品工程轮播图
      bannerJpgc() {
        var _this = this
        let data = {
          entTApplicationUuid: _this.webId,
          channelUuid: 'yiji0007',
          pageNum: 1,
          pageSize: 10
        }
        picArticles(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.JpgcPlayList = data.rows
            this.$nextTick(() => {
              this.swiper = new Swiper('#jpgcPhoto', {
                autoplay: 1,
                loop: true,
                speed: 8000,
                updateOnImagesReady : true,
                slidesPerView : 4,
                observer: true,
                observeParents: true,
                observeSlideChildren: true            
              })
              let nextTransForm = ''
            // 轮播图从暂停位置移动到原本应到的位置所用的时间
            let nextTime = 0

            // 鼠标悬浮暂停轮播
            this.swiper.container[0].onmouseover = function() {
              nextTransForm = document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform
              // 轮播图原本应移动到的位置
              let nextTransPosition =
                -1 *
                parseInt(
                  document
                    .getElementsByClassName('JpgcSwiper-container')[0]
                    .getElementsByClassName('swiper-wrapper')[0]
                    .style.transform.split('translate3d(')[1]
                    .split('px')[0]
                )

              // 鼠标悬浮时时轮播图位置
              let nowTransPosition =
                -1 *
                parseInt(
                  window
                    .getComputedStyle(
                      document
                        .getElementsByClassName('JpgcSwiper-container')[0]
                        .getElementsByClassName('swiper-wrapper')[0],
                      false
                    )['transform'].split('1, ')[2]
                    .split(',')[0]
                )
              // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
              let nowTransForm = window.getComputedStyle(
                document.getElementsByClassName('JpgcSwiper-container')[0].getElementsByClassName('swiper-wrapper')[0],
                false
              )['transform']
              // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
              nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
              // 改变行内transform属性
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
              // 不写也没关系
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
              this.swiper.stopAutoplay()
            }
            // 鼠标离开轮播图开始轮播
            this.swiper.container[0].onmouseout = function() {
              // console.log('leave' + nextTransForm)
              // 恢复原样
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
              this.swiper.startAutoplay()
            }
          })
          }
        })
      },

      getTopArtList() {
        var _this = this
        let data = {
          applicationUuid: this.webId
        }
        getTopArtList(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newsTextList = data
          }
        })
      },
     
      // 新闻动态-右
      newsCatalog() {
        var _this = this

        // 公司要闻
        let data01 = {
          entTApplicationUuid: _this.webId,
          channelUuid: 'yiji00020001',
          pageNum: 1,
          pageSize: 8
        }
        articles(data01).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newCatalogList01 = data.rows
          }
        })

        // 建投要闻
        let data02 = {
          entTApplicationUuid: _this.webIdGroup,
          // channelUuid: 'yiji00020002',
          channelUuid: '00190001',
          pageNum: 1,
          pageSize: 8
        }
        articles(data02).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newCatalogList02 = data.rows
          }
        })

        // 党群工作
        let data03 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji0003",
          pageNum: 1,
          pageSize: 8
        }
        articles(data03).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newCatalogList03 = data.rows
          }
        })

        // 媒体聚焦
        let data04 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00020005",
          pageNum: 1,
          pageSize: 8
        }
        articles(data04).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newCatalogList04 = data.rows
          }
        })

        //动态新闻第二部分
        //基层动态
        let data05 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00020003",
          pageNum: 1,
          pageSize: 8
        }
        articles(data05).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNewBasic1 = data.rows
          }
        })
        // 招标公告
        let data06 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00060002",
          pageNum: 1,
          pageSize: 8
        }
        getAllArtListByParentUuid(data06).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNewBasic2 = data.rows
          }
        })
        //行业动态
        let data07 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00020004",
          pageNum: 1,
          pageSize: 8
        }
        articles(data07).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNewBasic3 = data.rows
          }
        })

        //动态新闻第三部分
        //学习园地
        let data08 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji0005",
          pageNum: 1,
          pageSize: 8
        }
        articles(data08).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNenStu01 = data.rows
          }
        })

        //职工文苑
        let data09 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00040003",
          pageNum: 1,
          pageSize: 8
        }
        articles(data09).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNenStu02 = data.rows
          }
        })

        //一建之声
        let datab = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00040001",
          pageNum: 1,
          pageSize: 8
        }
        articles(datab).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.activeNenStu03 = data.rows
          }
        })

      },
      // 新闻轮播图
      picArticles() {
        var _this = this
        
        //新闻第一部分轮播图
        let data01 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "yiji00020001",
          pageNum: 1,
          pageSize: 5
        }
        picArticles(data01).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.flashImgList11 = data.rows
            this.$nextTick(() => {
              new Swiper('#newsFlash', {
                loop : true,
                autoplay: 3000,
                speed: 200,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                effect : 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
                paginationBulletRender: function (swiper, index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                }
              })
            })
          }
        })

      //新闻第三部分轮播图 （第2个轮播图）
      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00020003",
        pageNum: 1,
        pageSize: 5
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.flashImgList22 = data.rows
          this.$nextTick(() => {
            new Swiper('#newsFlash22', {
              loop : true,
                autoplay: 3000,
                speed: 200,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                effect : 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
                paginationBulletRender: function (swiper, index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                }
            })
          })
        }
      })
      },
    }
  }
  
</script>

<style lang="scss">
.homePage{
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: #f5f5f5;
  font: 14px Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;
}

//hot
.TTouTiao {
  width: 1200px;
  margin: 0 auto;
  height: 85px;
  margin-top: 10px;
  overflow: hidden;
  background: url(../assets/img/hot.png) left center no-repeat;
}
.TTouTiao .Tl {
  width: 81px;
  height: 85px;
  float: left;
}
.TTouTiao .Tr {
  width: 1100px;
  float: right;
}
.TTouTiao .Tr a {
  width: 100%;
  height: 85px;
  display: block;
  line-height: 85px;
  text-align: center;
  color: #000000;
  font-size: 28px;
  font-weight: bolder;
}

// 新闻动态部分
.homePage .Part1 {
  height: 366px;
}
.homePage .Tpage {
  width: 1200px;
  overflow: hidden;
  margin: 10px auto;
}
.homePage .NewsL {
  width: 535px;
  height: 360px;
  overflow: hidden;
  float: left;
}

.homePage .NewsL .flashImg {
  width: 100%;
  float: left;
  position: relative;
  height: 360px

}
.homePage .NewsL .flashImg-container{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.homePage .NewsL .flashImg-slide{
  height: 100%;
  width: 100%;
}
.homePage .NewsL .flashImg-slide .swiper_img{
  height: 100%;
  width: 100%;
  
}
.homePage .NewsL .flashImg .flashImg-slide .txt {
  width: 100%;
  height: 34px;
  overflow: hidden;
  background-color: #000000;
  margin-top: -34px;
  z-index: 2;
  opacity: 0.7;
}
.homePage  .NewsL .flashImg .txt .txtTitle {
  font-size: 12px;
  line-height: 34px;
  color: #ffffff;
  margin: 0 auto;
  overflow: hidden;/*超出部分隐藏*/
  text-overflow:ellipsis;/* 超出部分显示省略号 */
  white-space: nowrap;/*规定段落中的文本不进行换行 */
  width: 70%;/*需要配合宽度来使用*/
  margin-left: 2px;
  font-family: "微软雅黑", "宋体";
}
.homePage  .NewsL .swiper-pagination {
  position: absolute;
  text-align: right;
  z-index: 99;
  bottom: 8px;
}
.homePage  .NewsL .swiper-pagination-bullet {
  position: relative;
  width: 15px;
  height: 15px;
  margin: 0px 5px;
  color: #000000;
  font: 12px/15px "\5B8B\4F53";
  text-decoration: none;
  text-align: center;
  outline: 0;
  background: #CBCBCB;
  z-index: 99;
  border-radius: 0;
}
.homePage .flashImg .NewsL .flashImg-pagin .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 8px;
    width: 100%;
}
.homePage  .NewsL .swiper-pagination-bullet-active {
  background: #bc2d1c;
  color: #fff;
}
//新闻列表部分
.homePage  .NewsR {
  width: 640px;
  height: 360px;
  float: right;
}

.homePage  .NewsR .Tit {
  width: 100%;
  height: 43px;
  // overflow: hidden;
  float: left;
}
.homePage  .NewsR .Tit a {
  width: 115px;
  height: 43px;
  float: left;
  margin-right: 10px;
  display: block;
  text-align: center;
  line-height: 38px;
  color: #0062b3;
  font-size: 14px;
  font-weight: bolder;
  float: left;

}
a, a:focus, a:hover {
    text-decoration: none;
}
.homePage  .NewsR .Tit a:hover{
  color: #fff;
  background-color: #0062b3;

}
.homePage  .NewsR .Tit img{
  display: none;  
  margin-top: 5px;
  margin-left: 50px;
}
.homePage  .NewsR .Tit a:hover img{
  display: block;
}

.homePage  .NewsR .ItemList {
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
  clear: both;
}
.homePage  .NewsR .ItemList .comUl {
  padding: 0px;
  margin: 0px;
}
.homePage  .NewsR .ItemList .comUl li {
  width: 100%;
  height: 38px;
  line-height: 38px;
  // background: url(../../assets/img/li.png) 10px center no-repeat;
  margin: 0 auto;
  border-bottom: 1px #a4a4a4 dotted;
}
.homePage  .NewsR .ItemList .comUl li img{
  float: left;
  margin-top: 15px;
  margin-right: 16px;
}
.homePage  .NewsR .ItemList .comUl li a {
  float: left;
  // text-indent: 2em;
  white-space: nowrap;
  display: contents;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  margin-top: 8px;
  display: block;
  font: 14px Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;

}

.homePage .NewsR .ItemList .NewsItem .comUl li a:hover {
  animation: newshov  0.3s linear 1;
  color: #a2a6aa;
}
@keyframes newshov{
    from{transform:translateY(0px);}
    to{transform:translateY(-6px);}
}
.homePage .NewsR .comUl li .span {
  float: right;
  font-size: 14px;
}
.clear {
  width: 100%;
  height: 20px;
  overflow: hidden;
  display: block;
  clear: both;
}
//党建轮播图
.Part2{
  width: 100%;
  height: auto;
  overflow: hidden;
}
.homePage .Part2 .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;  
}
.homePage .Part2 .swiper-container{
  .swiper-wrapper{
    .swiper-slide{
      width: 100%;
      height: auto;
    }
  }
}
.Part2 .swiper-pagination {
  text-align: right;  
}

.homePage .Part2  .swiper-pagination-bullet-active {
  opacity: 1;
  background: #5599e4;
}

.homePage .Part2 .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;  
}

// 新闻第二部分

.homePage .Part3 {
  height: 366px;
  margin-top: 10px;
}

.homePage .Part3 .NewsR {
    width: 640px;
    height: 360px;
    float: left;
}
.homePage .Part3 .NewsL {
    width: 535px;
    height: 360px;
    overflow: hidden;
    float: right;
}
.homePage .Part4{
  width: 100%;
  overflow: hidden;
  height: 210px;
  background: url(../assets/img/p3.jpg);
  background-size: cover;
}
.Tpage {
    width: 1200px;
    overflow: hidden;
    margin: 0px auto;
}
.Part4 a {
    width: 378px;
    height: 147px;
    display: block;
    float: left;
    margin-top: 24px;
}
.Part4 .tpageImg{
  margin-left: 33px;
}
.homePage .Part4 img {
    display: inline-block;
    border: none;
}

//第五部分
.homePage .Part5{
  height: 366px;
  margin-top: 10px;
}
.homePage .Part5 .Left {
    width: 535px;
    height: 360px;
    overflow: hidden;
    float: left;
}

// 精品项目轮播图
.homePage .Part6 {
  height: 430px;
  overflow: hidden;
  background-size: cover;
}
.Part6 .tit {
    width: 100%;
    overflow: hidden;
    height: 45px;
}
.Part6 .tit .b {
    width: 200px;
    height: 45px;
    background: url(../assets/img/p4b.png) left center no-repeat;
    text-indent: 2em;
    color: #016ec1;
    font-size: 20px;
    line-height: 45px;
}

#Jpgc {
  height: 290px;
  overflow: hidden;
  width: 100%;
  padding-bottom: 10px;
  margin-top: 20px;
}

.homePage .Jpgcw .main_panel {
  margin: 0 auto;
  overflow: hidden;
  width: 1200px;
}
.homePage .jpmore {
  width: 100px;
    height: 36px;
    background-color: #e8e9ee;
    display: block;
    color: #6e706d;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    margin: 0 auto;
    border-radius: 3px;
    opacity: 0.7;
}
#Jpgc .JpgcSwiper-container .swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: content-box;
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
#Jpgc .JpgcSwiper-container .swiper-slide {
  width: 283px;
  height: 365px;
  overflow: hidden;
  margin-left: 20px;
  float: left;
  text-align: center;
}

#Jpgc .JpItem {
  width: 283px;
  height: 365px;
  display: block;
  overflow: hidden;
  text-align: center;
  float: left;
}

#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .img img{
  width: 283px;
  height: 197px;
}
#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .Tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #424242;
  margin: 5px 0px;
  font-weight: bolder;
  font-size: 13px;
  overflow: hidden;/*超出部分隐藏*/
  text-overflow:ellipsis;/* 超出部分显示省略号 */
  white-space: nowrap;/*规定段落中的文本不进行换行 */
  width: 90%;/*需要配合宽度来使用*/
  
}
#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .btn {
    width: 124px;
    height: 30px;
    border: 1px #ec0404 solid;
    line-height: 30px;
    color: #ec0404;
    margin: 10px auto 0px auto;
    font-size: 13px;
}
.homePage .NewsRInner.active a {
  color: #fff;
  background-color: #0062b3;
}
.homePage .NewsR .Tit img {
  display: block;
}

#Jpgc .swiper-container .swiper-wrapper{
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}
#jpgcPhoto {
    .swiper-button-next {
        right: auto;
    }
}

.homePage .Links .P3 .nr .link-container .swiper-slide {
    height: 30px;
}
</style>

